import { createApi } from "@reduxjs/toolkit/query/react";

import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import type {
  IAddCarryForwardRequest,
  TAddCarryForwardResponse,
  TGetCarryForwardByIdRequest,
  TGetCarryForwardByIdResponse,
  TGetCarryForwardsListingRequest,
  TGetCarryForwardsListingResponse,
  TUpdateCarryForwardRequest,
  TUpdateCarryForwardResponse,
} from "@/types/(company)/carryPolicy";

export const companyCarryForwardPoliciesApi = createApi({
  reducerPath: "companyCarryForwardPoliciesApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["CarryForwardSettings"],
  endpoints: (builder) => ({
    getAllCarryForwards: builder.query<
      TGetCarryForwardsListingResponse,
      TGetCarryForwardsListingRequest
    >({
      query: () => ({
        url: "/company/settings/carry-forward-policies",
        method: "GET",
      }),
      providesTags: ["CarryForwardSettings"],
    }),

    addCarryForward: builder.mutation<
      TAddCarryForwardResponse,
      IAddCarryForwardRequest
    >({
      query: (data) => ({
        url: "/company/settings/carry-forward-policies",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CarryForwardSettings"],
    }),

    getCarryForwardById: builder.query<
      TGetCarryForwardByIdResponse,
      TGetCarryForwardByIdRequest
    >({
      query: ({ id }) => ({
        url: "/company/settings/carry-forward-policies" + `/${id}`,
        method: "GET",
      }),
      providesTags: ["CarryForwardSettings"],
    }),

    updateCarryForward: builder.mutation<
      TUpdateCarryForwardResponse,
      TUpdateCarryForwardRequest
    >({
      query: (data) => ({
        url: "/company/settings/carry-forward-policies" + "/" + data.id,
        method: "PATCH",
        body: data.data,
      }),
      invalidatesTags: ["CarryForwardSettings"],
    }),

    // 204 No Content: resolves with no body.
    deleteCarryForward: builder.mutation<void, number>({
      query: (id) => ({
        url: "/company/settings/carry-forward-policies" + `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CarryForwardSettings"],
    }),
  }),
});

export const {
  useGetAllCarryForwardsQuery,
  useAddCarryForwardMutation,
  useGetCarryForwardByIdQuery,
  useLazyGetCarryForwardByIdQuery,
  useUpdateCarryForwardMutation,
  useDeleteCarryForwardMutation,
} = companyCarryForwardPoliciesApi;
